'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
require('./_index.scss.js');

var CLASSNAME = 'varta-banner';
/**
 * 
 * @param {*} param0 
 * @returns 
 */

function Banner(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(CLASSNAME, className)
  }, label);
}
Banner.propTypes = {
  /** Additional class name */
  className: PropTypes.string,

  /** Text for Banner */
  label: PropTypes.string
};

module.exports = Banner;
